<ion-modal
    *ngIf="asModal; else unwrapped"
    #actionSheet
    class="modal-action-sheet"
    [keepContentsMounted]="true"
    (ionModalDidDismiss)="didDismiss($event)">
    <ng-template>
        <ng-content *ngTemplateOutlet="unwrapped"></ng-content>
    </ng-template>
</ion-modal>

<ng-template #unwrapped>
    <lib-action-sheet-content
        (onClick)="onActionSheetButtonClick($event)"
        [buttons]="buttons"
        [showCancel]="showCancel" />
</ng-template>

<ng-content select="[toggleButton]"></ng-content>
